import { useMeetingContext } from "../../../../../context/MeetingContext";
import { useParams } from "react-router-dom";

export default function CallToAction() {
  const {
    name,
    setName,
    createMediaFile,
    setMediaFileName,
    mediaFileName,
    onClosePanel,
    uploadProgress,
    updatePresetId,
  } = useMeetingContext();

  const { folderId } = useParams();

  return (
    <div
      className="flex flex-col"
      // style={{
      //   background:
      //     "linear-gradient(164deg, #615B72 27.68%, #363347 66.87%, #2B2A3C 106.05%)",
      // }}
    >
      <div className="flex-1 flex flex-col p-6 md:p-8 gap-6">
        {/* Upload File Section */}
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-white font-montserrat text-2xl md:text-3xl font-bold tracking-tight">
            Upload File
          </h1>

          {/* Upload Area */}
          <div className="flex flex-col items-center gap-2 w-full max-w-md mt-4">
            <div
              className={`relative w-full max-w-[400px] rounded-lg border-gray-400 p-3 transition-colors ${
                uploadProgress > 0
                  ? "bg-gray-700 cursor-not-allowed opacity-75"
                  : "bg-[#5E5D60] hover:border-gray-300 cursor-pointer"
              }`}
              onDrop={async (e) => {
                if (uploadProgress > 0) return;
                e.preventDefault();
                const file = e.dataTransfer?.files?.[0];
                if (file) {
                  setMediaFileName(file); // Store the file object directly
                }
              }}
              onDragOver={(e) => {
                if (uploadProgress > 0) return;
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className="border-2 border-dashed w-full p-5 rounded-lg">
                <label
                  className={`flex flex-col items-center justify-center ${
                    uploadProgress > 0 ? "cursor-not-allowed" : "cursor-pointer"
                  }`}
                >
                  <div className="text-center mb-4">
                    <h3 className="text-white font-montserrat text-xl font-semibold mb-2">
                      Upload a File
                    </h3>
                    <p className="text-gray-400 font-montserrat text-sm">
                      {uploadProgress > 0
                        ? `Uploading... ${uploadProgress}%`
                        : "Click Here or Drag and Drop"}
                    </p>
                  </div>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.gif,.bmp,.webp,.svg,.tiff,.ico"
                    className="hidden"
                    disabled={uploadProgress > 0}
                    onChange={async (e) => {
                      if (uploadProgress > 0) return;
                      const file = e.target.files?.[0];
                      if (file) {
                        setMediaFileName(file); // Store the file object directly
                      }
                    }}
                  />
                </label>

                {/* Upload Progress Bar */}
                {uploadProgress > 0 && (
                  <div className="mt-4">
                    <div className="w-full bg-gray-600 rounded-full h-2">
                      <div
                        className="bg-purple-600 h-2 rounded-full transition-all duration-300 ease-out"
                        style={{ width: `${uploadProgress}%` }}
                      ></div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <p className="text-white font-montserrat text-xs mt-2">
              Recommended Size 394 x 1080
            </p>

            {/* Uploaded File Display */}
            {mediaFileName && (
              <div className="mt-4 p-4 bg-gray-700 bg-opacity-50 rounded-lg border border-gray-600 w-full max-w-md">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <span className="text-sm text-gray-300 truncate">
                      {mediaFileName.name}
                    </span>
                  </div>
                  <button
                    onClick={() => setMediaFileName("")}
                    className="text-gray-400 hover:text-gray-200"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-1.5 mt-2">
          <h2 className="text-white font-montserrat text-[23px] font-bold leading-[22px] tracking-[-0.18px]">
            Save
          </h2>

          <label className="text-white font-montserrat text-[13px] font-bold leading-[22px] tracking-[-0.18px]">
            Name your Slide:
          </label>

          <div className="flex items-center bg-white rounded-[10px] px-4 py-1.5">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Access your"
              className="flex-1 bg-transparent border-none outline-none text-[#606060] font-montserrat text-[13px] placeholder:text-[#606060]"
            />
          </div>
        </div>

        {/* Cancel and Save Buttons */}
        <div className="flex gap-4 mt-6 justify-center">
          <button
            className="bg-gray-600 text-white py-3 px-8 rounded-lg shadow hover:bg-gray-700 transition-colors font-bold cursor-pointer font-montserrat"
            type="button"
            onClick={() => {
              onClosePanel();
            }}
          >
            Cancel
          </button>
          <button
            className={`flex items-center justify-center px-11 py-2.5 rounded-[10px] bg-[#14B14B] text-white font-poppins text-[15px] font-normal leading-[22px] tracking-[-0.18px] transition-all hover:bg-[#12a043] active:scale-95 ${
              uploadProgress > 0 && uploadProgress < 100
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "cursor-pointer"
            }`}
            disabled={!mediaFileName}
            onClick={() => {
              if (!mediaFileName) return;
              createMediaFile({
                folderId,
                file: mediaFileName, // Pass the file object
                name,
                type: "document",
                id: updatePresetId,
              });
            }}
          >
            {uploadProgress > 0 && uploadProgress < 100
              ? "Uploading..."
              : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
